import {
  View,
  Text,
  StyleSheet,
  Animated,
  TouchableOpacity,
} from "react-native";
import React, { useRef, useState, useEffect } from "react";
import { Feather } from "@expo/vector-icons";
import MyText from "./MyText";
import { darkGreen, shadowSm } from "../../colors";

export default function Dropdown(props) {
  const { items, selected, setSelected } = props;

  const [open, setOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const dropdownListAnimation = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    if (open) {
      Animated.spring(dropdownListAnimation, {
        useNativeDriver: false,
        toValue: height,
      }).start();
    } else {
      Animated.timing(dropdownListAnimation, {
        useNativeDriver: false,
        toValue: 0,
      }).start();
    }
  }, [open, height]);
  const iconRotateInterpolator = dropdownListAnimation.interpolate({
    inputRange: [0, height],
    outputRange: ["0deg", "180deg"],
  });
  return (
    <View style={[styles.container, props.style]}>
      <TouchableOpacity
        activeOpacity={1}
        onPress={() => setOpen(!open)}
        style={styles.header}
      >
        <View style={{ flex: 1 }}>
          {items?.map((item, index) => {
            if (item.id === selected) {
              return (
                <MyText key={index} style={{ color: darkGreen }}>
                  {item.name}
                </MyText>
              );
            }
          })}
        </View>
        <Animated.View
          style={{ transform: [{ rotate: iconRotateInterpolator }] }}
        >
          <Feather name="chevron-down" size={24} color="#FF9356" />
        </Animated.View>
      </TouchableOpacity>
      <Animated.View
        style={[styles.dropdown, { height: dropdownListAnimation }]}
      >
        <View style={{ height: items.length * 50 }}>
          <View
            onLayout={(event) => {
              let { height } = event.nativeEvent.layout;
              setHeight(height);
            }}
          >
            {items.map((item, index) =>
              item.id !== selected ? (
                <TouchableOpacity
                  key={index}
                  style={styles.dropdownItems}
                  onPress={() => {
                    setSelected((prev) => ({ ...prev, selected: item.id }));
                    setOpen(false);
                  }}
                >
                  <MyText>{item.name}</MyText>
                </TouchableOpacity>
              ) : null
            )}
          </View>
        </View>
      </Animated.View>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    zIndex: 120,
    left: 0,
    width: 120,
    height: 32,
    borderRadius: 5,
    backgroundColor: "#fefefe",
    borderWidth: 1,
    borderColor: "#FF9356",
    
    
  },
  header: {
    height: 27,
    paddingLeft: 5,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  dropdown: {
    backgroundColor: "#fefefe",
    borderWidth: 1,
    borderColor: "#FF9356",
    marginTop: 2,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    zIndex: 120,
  },
  dropdownItems: {
    borderBottomWidth: 1,
    borderBottomColor: "#FF9356",
    paddingVertical: 10,
    paddingHorizontal: 5,
  },
});
